import React from 'react';
import { Icon, IconName } from '../icons';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'primary';

const CLASS_BY_TONE: Record<StatusTone, string> = {
  neutral: 'badge-neutral',
  info: 'badge-info',
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-error',
  primary: 'badge-primary',
};

/** Ordnet den ueblichen Status-Strings der Backend-Modelle eine Farbe zu. */
export function toneForStatus(status: string | null | undefined): StatusTone {
  switch ((status ?? '').toLowerCase()) {
    case 'draft':
    case 'idea':
    case 'planned':
    case 'new':
      return 'info';
    case 'scheduled':
    case 'pending':
    case 'created':
    case 'in_progress':
      return 'warning';
    case 'published':
    case 'posted':
    case 'approved':
    case 'done':
    case 'active':
    case 'ready':
      return 'success';
    case 'failed':
    case 'rejected':
    case 'error':
    case 'expired':
      return 'danger';
    default:
      return 'neutral';
  }
}

export interface StatusBadgeProps {
  tone?: StatusTone;
  /** Alternativ zum tone: Status-String, der ueber toneForStatus gemappt wird. */
  status?: string;
  icon?: IconName;
  className?: string;
  /** Tooltip, z. B. ein Satz, der den Status erklaert. */
  title?: string;
  children: React.ReactNode;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ tone, status, icon, className, title, children }) => {
  const resolved = tone ?? toneForStatus(status);
  return (
    <span className={`badge ${CLASS_BY_TONE[resolved]} ui-status-badge${className ? ` ${className}` : ''}`} data-tone={resolved} title={title}>
      {icon && <Icon name={icon} size={12} />}
      {children}
    </span>
  );
};

export default StatusBadge;
